module.exports = __webpack_public_path__ + "62cf02eca9f4379e7ad85b9b02f8b011.svg";